import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import AdminNavigation from './AdminNavigation/AdminNavigation';
import ClientNavigation from './ClientNavigation/ClientNavigation';
import ClientNavigationAdmin from './ClientNavigationAdmin/ClientNavigationAdmin';
import PatronNavigation from './PatronNavigation/PatronNavigation';
import StreamNavigation from './StreamNavigation/StreamNavigation';
import SwitchUser from './SwitchUser/SwitchUser';

import './Navigation.css';

class Navigation extends Component {
	renderStreamNavigation = () => {
		if ((this.props.location.pathname.indexOf('/stream') !== -1 || this.props.location.pathname.indexOf('/demo') !== -1) && this.props.streamEvent.client_id) {
			return (
				<StreamNavigation
					showStreamDescriptionModal={this.props.showStreamDescriptionModal}
					showStreamArtistsModal={this.props.showStreamArtistsModal}
					streamEvent={this.props.streamEvent}
				></StreamNavigation>
			);
		}
	}

	render() {
		return(
			<div>
				<nav
					role="navigation"
					id="navigation"
					hidden={!this.props.isNavigationOpen && 'hidden'}
					className={!this.props.isNavigationOpen ? 'showtix-navigation' : 'showtix-navigation is-active'}
				>
					{(this.props.user.role === 'client' || this.props.user.role === 'admin') ?  (
						<div>
							{ this.renderStreamNavigation() }
							{ this.props.user.role === 'admin' ?
								<SwitchUser 
									isGodMode={this.props.isGodMode}
									toggleNav={this.props.toggleNav} 
									clients={this.props.clients}
									switchUser={this.props.switchUser}
									logoutSwitchUser={this.props.logoutSwitchUser}
								/>
							:
								(this.props.isGodMode &&
									<SwitchUser 
										isGodMode={this.props.isGodMode}
										toggleNav={this.props.toggleNav} 
										clients={this.props.clients}
										switchUser={this.props.switchUser}
										logoutSwitchUser={this.props.logoutSwitchUser}
									/>
								)
							}
							{/* Remove Box Office for Admin since they dont have events */}
							{ this.props.user.role === 'admin' ?
								<ClientNavigationAdmin 
									toggleNav={this.props.toggleNav} 
								/>
							:
								<ClientNavigation 
									toggleNav={this.props.toggleNav} 
								/>
							}
							
							<PatronNavigation 
								user={this.props.user}
								toggleNav={this.props.toggleNav}
								toggleReprintOrder={this.props.toggleReprintOrder}
                                makeDonation={this.props.makeDonation}
                                location={this.props.location}
                                client={this.props.client}
							/>
						</div>
					) : 
						(this.props.user.role === 'box-office' ? 
							<div>
								{ this.renderStreamNavigation() }
								{ this.props.isGodMode &&
									<SwitchUser 
										isGodMode={this.props.isGodMode}
										toggleNav={this.props.toggleNav} 
										clients={this.props.clients}
										switchUser={this.props.switchUser}
										logoutSwitchUser={this.props.logoutSwitchUser}
									/>
								}
								<AdminNavigation 
									toggleNav={this.props.toggleNav} 
								/>
								<PatronNavigation 
									user={this.props.user}
									toggleNav={this.props.toggleNav} 
									toggleReprintOrder={this.props.toggleReprintOrder}
                                    makeDonation={this.props.makeDonation}
                                    location={this.props.location}
                                    client={this.props.client}
								/>
							</div>
						:
							<div>
								{ this.renderStreamNavigation() }
								<PatronNavigation 
									user={this.props.user}
									toggleNav={this.props.toggleNav} 
									toggleReprintOrder={this.props.toggleReprintOrder}
									makeDonation={this.props.makeDonation}
                                    location={this.props.location}
                                    client={this.props.client}
								/>
							</div>
						)
					}
				</nav>
			</div>
		)
	}
}

Navigation.propTypes = {
    client: PropTypes.object,
    isNavigationOpen: PropTypes.bool,
    toggleNav: PropTypes.func,
    toggleReprintOrder: PropTypes.func,
    makeDonation: PropTypes.func,
    switchUser: PropTypes.func,
	showStreamDescriptionModal: PropTypes.func,
	showStreamArtistsModal: PropTypes.func
}

export default withRouter(Navigation);;



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js